/**
 * Master switch for the product guided tour (intro modal, dashboard tour,
 * job-details tour, and the header restart button). Off by default until
 * the experience is reworked. Toggle via `VITE_GUIDED_TOUR_ENABLED=true`.
 */
export const GUIDED_TOUR_ENABLED =
  import.meta.env.VITE_GUIDED_TOUR_ENABLED === 'true';

/**
 * Enables the live Azure Speech-to-Text fallback during interviews. When on,
 * the candidate's microphone is also tapped (in parallel to LiveKit publish)
 * and streamed to the backend, which produces a per-question realtime
 * transcript. Assessment uses it only when the post-hoc Whisper transcript
 * for that question is empty. Off by default — opt-in until validated.
 */
export const REALTIME_AZURE_FALLBACK_ENABLED =
  import.meta.env.VITE_REALTIME_AZURE_FALLBACK_ENABLED === 'true';

/**
 * Shows the MCP (Claude / ChatGPT connector) card on the Integrations page.
 * Off by default while the MCP feature is being reworked. Toggle via
 * `VITE_MCP_INTEGRATION_ENABLED=true`.
 */
export const MCP_INTEGRATION_ENABLED =
  import.meta.env.VITE_MCP_INTEGRATION_ENABLED === 'true';
